import React from 'react'
import { DateTime } from 'luxon'
import Container from '@material-ui/core/Container'
import { makeStyles } from '@material-ui/core/styles'
import BookingsList from './bookings-list'
import { flags, useFeatureFlags } from 'lib/feature-flags'

const useStyles = makeStyles(theme => ({
  tabWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '24px',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      padding: 0,
    },
  },
  showCancellations: {
    [theme.breakpoints.down('xs')]: {
      marginTop: '20px',
    },
  },
  containerStyles: {
    [theme.breakpoints.down('xs')]: {
      padding: '0',
      marginBottom: '60px',
    },
  },
}))

const BookingsTabs = ({ selectedTab = 0 }) => {
  const [isCoachOnboardingEnabled] = useFeatureFlags([
    flags.FLAG_COACH_ONBOARDING,
  ])
  const classes = useStyles()

  const upcomingBookingsDateRange = {
    from: DateTime.now()
      .startOf('day')
      .toISO(),
    to: null,
  }

  const pastBookingsDateRange = {
    from: DateTime.now()
      .minus({ days: 30 })
      .startOf('day')
      .toISO(),
    to: DateTime.now()
      .minus({ days: 1 })
      .endOf('day')
      .toISO(),
  }

  return (
    <Container className={classes.containerStyles}>
      {selectedTab === 0 && isCoachOnboardingEnabled && (
        <BookingsList
          timeframe="upcoming"
          startDateTime={upcomingBookingsDateRange}
          emptyStateTitle="No Scheduled Sessions"
          emptyStateSubtitle='You can view the booking type you created in the "My Programs" page on the left navigation. When a student books a session with you, it will appear in the upcoming tab on this page. Additionally, you can organize a group event to show up on this page as well.'
          isCoachOnboardingEnabled={isCoachOnboardingEnabled}
        />
      )}
      {selectedTab === 0 && !isCoachOnboardingEnabled && (
        <BookingsList
          timeframe="upcoming"
          startDateTime={upcomingBookingsDateRange}
          emptyStateTitle="Schedule"
          emptyStateSubtitle="Customers that schedule a session with you will appear here. First you'll need to set your availability which can be found in Settings  -->"
          isCoachOnboardingEnabled={isCoachOnboardingEnabled}
        />
      )}
      {selectedTab === 1 && (
        <BookingsList
          reverse
          timeframe="past"
          startDateTime={pastBookingsDateRange}
          emptyStateTitle="No past sessions"
          emptyStateSubtitle="Previous sessions will appear here after they occur. First you'll need to set your availability which can be found in Settings  -->"
          isCoachOnboardingEnabled={isCoachOnboardingEnabled}
        />
      )}
    </Container>
  )
}

export default BookingsTabs
